import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden } from '@material-ui/core'
import ReactPlayer from 'react-player'
import { useTheme } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import screenfull from 'screenfull';

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"
import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import playVideoIcon from "../../../images/playVideoIcon.svg"
import pauseVideoIcon from "../../../images/pauseVideoIcon.svg"
import restartVideoIcon from "../../../images/restartVideoIcon.svg"

const toHHMMSS = (secs) => {
    var sec_num = parseInt(secs, 10)
    var hours   = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours,minutes,seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v,i) => v !== "00" || i > 0)
        .join(":")
}

const FormatVideo = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  const playerRef = useRef(null)

  const [playing, setPlaying] = useState(false)
  const [played, setPlayed] = useState(0)
  const [alreadyPlayed, setAlreadyPlayed] = useState(false)
  const [volume, setVolume] = useState(1)
  const [totalDuration, setTotalDuraton] = useState(0)
  const [playedSecond, setPlayedSecond] = useState(0)
  useEffect(() => {
    if (playerRef?.current) {
      playerRef.current.seekTo(0)
      setPlayed(0)
      setPlaying(false)
    }
    if (format?.isDone) {
      setAlreadyPlayed(true)
    } else {
      setAlreadyPlayed(false)
    }
  }, [format])

  const theme = useTheme();
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const observedElementRef = useRef(null);
  const modifiedElementRef = useRef(null);

  const innerDimensions = (node) => {
    var computedStyle = getComputedStyle(node)

    let width = node.clientWidth // width with padding
    let height = node.clientHeight // height with padding

    height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
    width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
    return { height, width }
  }
  useEffect(() => {
    if (observedElementRef.current && modifiedElementRef?.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          if (mediaQueryUpSm) {
            let dims = innerDimensions(observedElementRef?.current)
            let aspectRatio = dims?.width / dims?.height
            if (aspectRatio > 16/9) {
              modifiedElementRef.current.style.width = "unset"
              modifiedElementRef.current.style.height = "100%"
            } else {
              modifiedElementRef.current.style.width = "100%"
              modifiedElementRef.current.style.height = "unset"
            }
          } else {
            modifiedElementRef.current.style.width = "100%"
            modifiedElementRef.current.style.height = "unset"
          }
        }
      }));
      observer.observe(observedElementRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [observedElementRef?.current, modifiedElementRef?.current, mediaQueryUpSm]);

  const onEnded = (e) => {
    setPlaying(false)
    setAlreadyPlayed(true)
  }

  useEffect(() => {
    if (viewPlanCours && playing) {
      setPlaying(false)
    }
  }, [viewPlanCours, playing])


  const [viewControls, setViewControls] = useState(false)
  useEffect(() => {
    let int;
    if (playing === true) {
      setViewControls(true)
      int = setTimeout(() => {
        setViewControls(false)
      }, 3000);
    } else {
      const reactPlayer = document.querySelector('.react-player');
      if (reactPlayer) { screenfull.exit(reactPlayer) }
      setViewControls(false)
    }
    return () => {
      if (int) {
        clearTimeout(int);
      }
    }
  }, [playing]);


  /* EDITOR ADMIN */
  const [editorStep, setEditorStep] = useState(0)

  useEffect(() => {
    if (isEditor) {
      if (editorStep === 1) {
        setPlaying(true)
      } else {
        setPlaying(false)
        playerRef?.current?.seekTo(0)
      }

      if (editorStep === 2) {
        setAlreadyPlayed(true)
      } else {
        setAlreadyPlayed(false)
      }
    }
  }, [editorStep, isEditor])
  /* END EDITOR ADMIN */

  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Étapes</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center"}}>
              <Box
                onClick={() => {setEditorStep(0)}}
                sx={{padding:"0px 5px", height:"20px", background:editorStep===0?"red":"black", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                Début
              </Box>
              <Box
                onClick={() => {setEditorStep(1)}}
                sx={{padding:"0px 5px", height:"20px", background:editorStep===1?"red":"black", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                Lecture
              </Box>
              <Box
                onClick={() => {setEditorStep(2)}}
                sx={{padding:"0px 5px", height:"20px", background:editorStep===2?"red":"black", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                Fin
              </Box>
            </Box>
          </Box>
          <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Vidéo</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Box>
                Url :
              </Box>
              <Box sx={{flex:1}}>
                <input
                  value={format?.playbackId}
                  style={{width:"100%"}}
                  onChange={(e) => {
                    superAdminContext?.onSequenceChange(
                      'playbackId',
                      e.target.value,
                      superAdminContext?.adminPlayerIndexes
                    )
                  }}
                />
              </Box>
            </Box>
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}
      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        noPartInfos
        withFlexAndJustifyContent
        passRef={observedElementRef}
        onlyContent={onlyContent}
      >
        <Hidden smUp>
          <Box sx={{
            maxWidth:"100%",
            display:"flex",
            flexDirection:"column",
            gap:"10px",
            overflow:"hidden",
            userSelect:"none",
            textAlign:"center",
            marginBottom:"30px"
          }}>
            <EditableField
              field={format?.title}
              type="title"
              isEditor={isEditor}
              sx={{
                fontSize:"26px",
                whiteSpace:"noWrap",
                textOverflow:"ellipsis",
                overflow:"hidden"
              }}
            />
            <EditableField
              field={format?.text}
              type="text"
              isEditor={isEditor}
              sx={{
                fontSize:"16px",
                overflow:"hidden",
                lineHeight: "130%",
                opacity:0.8,
              }}
            />
            <Box sx={{ display:"flex", gap:"4px", justifyContent:"center"}}>
              <EditableField
                field={format?.duration}
                type="duration"
                isEditor={isEditor}
                sx={{
                  fontSize:"14px",
                  whiteSpace:"noWrap",
                  textOverflow:"ellipsis",
                  overflow:"hidden"
                }}
              />
              <Box sx={{
                fontSize:"14px",
                whiteSpace:"noWrap",
                textOverflow:"ellipsis",
                overflow:"hidden"
              }}>
                {`min`}
              </Box>
            </Box>
          </Box>
        </Hidden>
        <Box
          ref={modifiedElementRef}
          sx={{
            aspectRatio:"16/9",
            width:"100%",
            //height:"100%",
            background:playing ? "transparent" : "url('https://image.mux.com/"+format?.playbackId +"/thumbnail.png?width=1280&height=720&fit_mode=crop')",
            backgroundRepeat:"no-repeat",
            backgroundSize:"cover",
            position:"relative",
            cursor:"pointer",
          }}
          onClick={() => {
            if (isEditor !== true) {
              setPlaying(!playing)
            }
          }}
        >
          {(onlyContent !== true || isEditor === true) &&
            <ReactPlayer
              className="react-player"
              loop={false}
              disableRemotePlayback={true}
              config={{ file: { attributes: { playsInline: true, }, }, }}
              url={'https://stream.mux.com/' + format?.playbackId + '.m3u8'}
              volume={volume}
              width="100%"
              height="100%"
              style={{
                overflow:"hidden",
                //aspectRatio:"16/9",
                position:"absolute",
                visibility:playing?"visible":"hidden",
                top:0,
                left:0,
              }}
              onPause={(e) => {
                console.log("onPause")
                setPlaying(false)
              }}
              onError={(e) => {
                console.log("error playing video, formatID : "+format?.id)
                setPlaying(false)
              }}
              onEnded={onEnded}
              playing={playing}
              onDuration={(duration) => {
                setTotalDuraton(duration)
              }}
              onProgress={(e) => {
                console.log(e.played * 100)
                setPlayed(e.played * 100)
                setPlayedSecond(e.playedSeconds)
                if (e.played * 100 >= 100) {
                  onEnded(e)
                }
              }}
              ref={playerRef}
            />
          }
          <Box sx={{
            //background:"rgba(0,0,0,0.4)",
            position:"absolute",
            top:0,
            left:0,
            width:"100%",
            height:"100%",
            display:playing ? "flex" : "none",
            opacity:viewControls?1:0,
            //opacity:1,
            color:"white",
            padding:"25px",
            gap:"25px",
            justifyContent:"center",
            alignItems:"center",
            "&:hover" : {
              opacity:1
            }
          }}>
            <Box sx={{width:["55px", "70px", "70px", "100px"], minWidth:["55px", "70px", "70px", "100px"], userSelect:"none",}}>
              <img src={pauseVideoIcon} style={{width:"100%"}} />
            </Box>
            <Box onClick={(e) => {e.stopPropagation()}} sx={{
              position:"absolute",
              left:0,
              width:"100%",
              bottom:0,
              height:["50px", "50px", "50px", "50px"],
              background:"rgba(0,0,0,0.4)",
              display:"flex",
              gap:["10px", "15px", "15px", "20px"],
              alignItems:"center",
              padding : ["0px 10px", "0px 20px"],
              cursor:"default",
            }}>
              <Box sx={{
                flex:1,
              }}>
                <Box sx={{
                  width:played+"%",
                  height:"5px",
                  background:"white"
                }}>
                </Box>
              </Box>
              <Box>
                {(totalDuration >= 0 && playedSecond >=0) ? (
                  <>
                    {toHHMMSS(totalDuration - playedSecond)}
                  </>
                ) : (
                  "00:00"
                )}
              </Box>
              <Box sx={{cursor:"pointer"}} onClick={(e) => {
                e.stopPropagation();
                if (volume === 1) {
                  setVolume(0)
                } else {
                  setVolume(1)
                }
              }}>
                {volume === 1 &&
                  <VolumeUpIcon />
                }
                {volume === 0 &&
                  <VolumeOffIcon />
                }
              </Box>
              <Box sx={{cursor:"pointer"}} onClick={(e) => {
                e.stopPropagation();
                const reactPlayer = document.querySelector('.react-player');
                if (reactPlayer) { screenfull.request(reactPlayer) }
              }}>
                <FullscreenIcon />
              </Box>
            </Box>
          </Box>
          <Box sx={{
            background:"rgba(0,0,0,0.4)",
            position:"absolute",
            top:0,
            left:0,
            width:"100%",
            height:"100%",
            display:playing ? "none" : "flex",
            color:"white",
            padding:"25px",
            gap:"25px",
            justifyContent:["center", "space-between"],
            alignItems:"center",
          }}>
            <Hidden smDown>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                gap:["10px", "10px", "10px", "15px"],
                overflow:"hidden",
                userSelect:"none",
              }}>
                <EditableField
                  field={format?.title}
                  type="title"
                  isEditor={isEditor}
                  sx={{
                    fontSize:["42px", "42px", "42px", "46px"],
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    overflow:"hidden"
                  }}
                />
                <EditableField
                  field={format?.text}
                  type="text"
                  isEditor={isEditor}
                  sx={{
                    ontSize:["20px", "20px", "20px", "24px"],
                    overflow:"hidden",
                    lineHeight: "130%",
                    opacity:0.8,
                  }}
                />
                <Box sx={{ display:"flex", gap:"4px"}}>
                  <EditableField
                    field={format?.duration}
                    type="duration"
                    isEditor={isEditor}
                    sx={{
                      fontSize:"15px",
                      whiteSpace:"noWrap",
                      textOverflow:"ellipsis",
                      overflow:"hidden"
                    }}
                  />
                  <Box sx={{
                    fontSize:"15px",
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    overflow:"hidden"
                  }}>
                    {`min`}
                  </Box>
                </Box>
              </Box>
            </Hidden>
            <Box sx={{width:["55px", "70px", "70px", "100px"], minWidth:["55px", "70px", "70px", "100px"], userSelect:"none",}}>
              <img src={alreadyPlayed ? restartVideoIcon : playVideoIcon} style={{width:"100%"}} />
            </Box>
          </Box>
        </Box>
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={false}
            disabled={!alreadyPlayed}
            type="button"
            field={languageValues?.formation?.formatVideo?.buttonNext[actLanguage]}
            sx={{}}
            onClick={() => {
              if (isEditor !== true) {
                manageFormatResponse(format, [{ key: 'isDone', value: true }])
                manageSlide(1)
              }
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatVideo
